export default [
  {
    path: '/dashboard/sales',
    name: 'dashboard-sales',
    component: () => import('@/views/dashboard/SalesDashboard.vue'),
    meta: {
      pageTitle: 'Sales Dashboard',
      breadcrumb: [
        {
          text: 'Dashboard',
          to: '/',
        },
        {
          text: 'Sales',
          active: true,
        },
      ],
    },
  },
  {
    path: '/dashboard/storage',
    name: 'dashboard-storage',
    component: () => import('@/views/dashboard/StorageDashboard.vue'),
    meta: {
      pageTitle: 'Storage & Locations Dashboard',
      breadcrumb: [
        {
          text: 'Dashboard',
          to: '/',
        },
        {
          text: 'Storage & Locations',
          active: true,
        },
      ],
    },
  },
]
